module.exports = __webpack_public_path__ + "static/media/ftn-omasp-auth.1bca515b.svg";